import React, {useEffect, useState} from "react";
import {useNavigate, Link} from "react-router-dom";
import TimeOutModal from "../Assets/TimeOutModal";
import useInput from "../Assets/UseInput";
import {useTranslation} from "react-i18next";
import {Col, Alert, Form, FormFeedback, FormGroup, Input, Label, Row} from "reactstrap";
import BreadCrumb from "../Layout/BreadCrumb";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

var serialize = require('serialize-javascript');
var moment = require('moment')
function FamilyPartner (props) {
    // fetch data from local Storage
    let history = useNavigate();
const [d, setDead] = useState()
    const [Age, setAge]= useState()
    const [isLoading, setIsLoading] = useState(false);

    const next = () => {
        const family = JSON.parse(localStorage.getItem('family'))
        let nextLocation ={}
        if (family.Field18HasChildren === "yes"){
            nextLocation = {
                pathname: '../family-children',
                state: { d: d }
            }
        }else if (family.Field19HasParents === "yes"){
            nextLocation = {
                pathname: '../family-parents',
                state: { d: d }
            }
        }else if (family.Field20HasPersons === "yes"){
            nextLocation = {
                pathname: '../family-other',
                state: { d: d }
            }
        }else if (Age > 15){
            nextLocation = {
                pathname: '../job',
                state: { d: d }
            }
        }else {
            nextLocation = {
                pathname: '../circumstances',
                state: { d: d }
            }
        }
        history(nextLocation)
    }

    const handleNext = (e) =>{
        e.preventDefault()
        next()
    }

    const prevLocation = {
        pathname: '../family',
        state: { d: d }
    }
    const handlePrev = (e) =>{
        e.preventDefault()
        history(prevLocation)
    }

    const [Field24Birthdate, setField24Birthdate] = useState("");
    
    // set control value and name to classic Inputs using the custom Hook useInput
    const {value: Field23Firstname, bind: bindField23Firstname, reset: setField23Firstname } = useInput('');
    const {value: Field22Name, bind: bindField22Name, reset: setField22Name } = useInput('');

    const [Field24BirthdateError, setField24BirthdateError]= useState("")
    const [Field24BirthdateEarlierError, setField24BirthdateEarlierError]= useState("")
    const [Field24BirthdateFormatError, setField24BirthdateFormatError]= useState("")
    

    // radio Input custom handleChange
    const [Field25Situation, setField25Situation] = useState("");
    const handleChangeField25Situation = (e) => {
        let value = e.target.value
        setField25Situation(value);
    }

    const AgeCalculation = (e) => {
        setField24Birthdate(e.target.value)
            //console.log(birth);
          //console.log(e.target.value)
            let birthDate = moment(e.target.value, "YYYY-MM-DD")
            let validDate = moment(birthDate, 'YYYY-MM-DD', true).isValid()
            //console.log(Field24Birthdate)
            if (validDate) {
                let pastDate = birthDate.isBefore(moment())
                setField24BirthdateFormatError(false)
                if (!pastDate) {
                    setField24BirthdateError(true)
                    setField24BirthdateEarlierError(true)
                } else {
                    setField24BirthdateEarlierError(false)
                    setField24BirthdateError(false)
                    //console.log(birth)
                    let Age = moment().diff(birthDate, 'years', false)
                    setAge(Age);
                    //console.log(Age)
                }
            }
    }

    const [stored, setStored] =  useState("")

    useEffect(() => {
                    window.scrollTo(0, 0)
        const fetchData = async () => {
            setIsLoading(true);
            const storedAge = localStorage.getItem('Age')
            setAge(storedAge)
            const dead = localStorage.getItem('isDead')
            //console.log(dead)
            dead === "true" ? setDead(true) : setDead(false)
            setIsLoading(false);

            const familyPartner = JSON.parse(localStorage.getItem('familyPartner'))

            if (familyPartner){
                setStored(true)
                setField24Birthdate(familyPartner.Field24Birthdate)
                setField23Firstname(familyPartner.Field23Firstname)
                setField22Name(familyPartner.Field22Name)
                setField25Situation(familyPartner.Field25Situation)
            }
        };
        fetchData()
    }, []);



    // Submit and validation
    const [NotValid, setNotValid] = useState(false)
    const handleSubmit = (evt) => {

                    window.scrollTo(0, 0)
        evt.preventDefault();
        let notValid = Field24Birthdate === ""|| Field23Firstname === ""|| Field22Name === ""
        //console.log(notValid)
        setNotValid(notValid)
        if (!notValid){
            let familyPartner = {
                Field24Birthdate : Field24Birthdate,
                Field23Firstname : Field23Firstname,
                Field22Name : Field22Name,
                Field25Situation : Field25Situation
            }
            //let stringInfo = JSON.stringify(familyPartner)
            let stringInfo = serialize(familyPartner, {isJSON: true});
            localStorage.setItem("familyPartner" , stringInfo)
            if ( d && Field25Situation === "actif"){
                //console.log("hassssss")
                localStorage.setItem("hasActivePartner" , true)
            }
            if ( d && Field25Situation === "inactif"){
                localStorage.setItem("hasActivePartner" , false)
            }
            //console.log(JSON.parse(stringInfo))
            next()
        }

    }



    const { i18n } = useTranslation();
    return (
        <div className={d? "death" : "injured"}>
            { !!isLoading ? (
                    <div className={'text-center pt-5'}><img className={'d-inline-block'} src="/accidentinfo/spinner.svg" alt=""/></div>
                ) :
                <div className={"container"}>
                    <TimeOutModal i18n={i18n} />
<BreadCrumb n={3}/>
                    <Row>
                        <Col>

                            <h3>{ d? i18n.t("FAMILYTITLEDEATH"): i18n.t("FAMILYTITLE") }</h3>
                            <h4 className={"text-primary"}>{  d? i18n.t("PARTNERFAMILYTITLEDEATH"): i18n.t("PARTNERFAMILYTITLE") }</h4>
                            { NotValid &&
                            <Alert color="danger"><FontAwesomeIcon className="pre" icon={['fas', 'hand-point-right']} /> <strong>{  i18n.t('Erreur(s) dans votre formulaire') }</strong>
                                <hr className="message-inner-separator"/>
                                <p>{i18n.t('Merci de vérifier les champs indiqués en rouge')}</p></Alert>
                            }
                            <Form>
                                <div className="formlevel01">
                                    <FormGroup className={(NotValid && Field23Firstname === "") ? "text-danger" : "text"}>
                                        <Label htmlFor="field23Firstname">{i18n.t("FIRSTNAMEPARTNER")} <span className={"text-danger"}>*</span></Label>
                                        <Input type="text"
                                               name="Field23Firstname" placeholder={i18n.t("PLACEHOLDERFIRSTNAMEPARTNERDEATH")}
                                               {...bindField23Firstname}  invalid={(NotValid && Field23Firstname === "")} />
                                            {(NotValid && Field23Firstname === "") &&<span className="help-block form-error">{i18n.t("Obligatoire")}</span>}
                                    </FormGroup>
                                    <FormGroup className={(NotValid && Field22Name === "")? "text-danger" : "text"}>
                                        <Label htmlFor="field22Name"
                                               >{i18n.t("NAMEPARTNER")} <span className={"text-danger"}>*</span></Label>
                                        <Input type="text" maxLength={500} name="Field22Name"
                                               placeholder={i18n.t("PLACEHOLDERNAMEPARTNERDEATH")}
                                               {...bindField22Name} invalid={(NotValid && Field22Name === "")}/>
                                            <FormFeedback>{i18n.t("Obligatoire")}</FormFeedback>
                                    </FormGroup>
                                    <FormGroup className={((Field24BirthdateError) || (Field24BirthdateEarlierError) || (Field24BirthdateFormatError))? "text-danger" : "text"}>
                                        <Label for="Field24Birthdate">{i18n.t("BIRTHDATEDATA")} <span className={"text-danger"}>*</span></Label>
                                            <Input onChange={AgeCalculation} type="date" value={Field24Birthdate} invalid={(NotValid && Field24Birthdate === "")}/>
                                            <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            {Field24BirthdateEarlierError && <p>{i18n.t("La date doit être dans le passé")}</p>}
                                            {Field24BirthdateFormatError && <p>{i18n.t("La date n'est pas correctement encodée")} : {i18n.t("jj/mm/yyyy")} </p>}
                                        
                                    </FormGroup>
                                    <FormGroup className={(NotValid && Field25Situation)? "text-danger" : "text"} check>
                                        <Label htmlFor="Field25Situation">{i18n.t("JOBPARTNER")}</Label>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field25Situation"
                                                       value="actif" onChange={handleChangeField25Situation} checked={(Field25Situation === "actif")} />
                                                    {i18n.t("actif")}
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field25Situation"
                                                       value="inactif" onChange={handleChangeField25Situation} checked={(Field25Situation === "inactif")} />
                                                    {i18n.t("inactif")}
                                            </Label>
                                        </div>
                                        {(NotValid && Field25Situation === "") &&<span className="help-block form-error">{i18n.t("Obligatoire")}</span>}
                                    </FormGroup>

                                    <div className="button-wrapper">
                                        <button type="submit"  onClick={handleSubmit} className="btn btn-primary small">{ !stored ?  i18n.t('Enregistrer') : i18n.t('Mettre à jour') }<FontAwesomeIcon icon={['fas', 'arrow-right']} /></button>
                                    </div>
                                </div>

                            </Form>

                            <span className={"text-danger"}>*</span> {  i18n.t('Renseignement indispensable') }<br />
                        </Col>
                    </Row>
                    
                </div>}
        </div>
    )
}
export default FamilyPartner

